import React, { Component } from 'react'

class ShowFolderInfo extends Component {
    render() {
        const {folder_info, folder_default} = this.props;
        return (
            <div className="p-15">
                <p>ID danh mục:</p>
                <div className="form-control">
                    <input 
                    type="text" 
                    name="name"
                    className="input-control dark fullWidth"
                    value={folder_info.image_forderId}
                    placeholder="Tên sản phẩm"
                    disabled
                    />
                </div>
                <p>Tên danh mục:</p>
                <div className="form-control">
                    <input 
                    type="text" 
                    name="name"
                    className="input-control dark fullWidth"
                    value={folder_info.name}
                    placeholder="Tên sản phẩm"
                    disabled
                    />
                </div>
                {folder_info.image_forderId !== folder_default &&
                    <div className="text-link-dark" onClick={() => this.props.setDefault({image_forderId: folder_info.image_forderId, name: folder_info.name})}>Đặt làm mặc định</div>
                }
            </div>
        )
    }
}

export default ShowFolderInfo
